export { AggregatingResultCardContainer as default } from './aggreagating-result-card-container';
export * from './aggreagating-result-card-container';
